import type { AssetAssociationWithDevice } from '../../components/assets/details/types';
import type { AssociatedDevice } from '../../components/assets/types';
import { pushToObjectMapArray } from '../reducerHelper';

export const getAssetAssociatedDeviceMap = (
    assetAssociationWithDevice: AssetAssociationWithDevice[]
): {
    [key: string]: AssociatedDevice[];
} => {
    const deviceMap: { [key: string]: AssociatedDevice[] } = {};
    for (const association of assetAssociationWithDevice) {
        if (association._embedded.device !== undefined) {
            pushToObjectMapArray(deviceMap, association.asset_id, {
                device: association._embedded.device,
                associationId: association.id,
            });
        }
    }
    return deviceMap;
};
